import { DialogContentText, DialogTitle, Tooltip } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import DatePicker from "@mui/lab/DatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { useLocation } from "react-router-dom";
import {
  hasInvalidPoItemUnCode,
  hasInvalidUnCode,
  isInvalidMaxPickupNumber,
  isInvalidMaxWareHouseRemarks,
} from "../../helper/HelperFunctions";
import {
  hasInvalidPalletSpaces,
  hasInvalidShipQuantities,
  hasInvalidShipUnits,
  hasInvalidSlipSheets,
  hasInvalidTotals,
  isDivisibleShipQuantity,
  isInvalidPalletSpacesValue,
  isInvalidShipQuantityValue,
  isInvalidSlipSheetsValue,
  isLessThanRemainingQuantity,
} from "../../helper/ShipUnitUtilities";
import { getJsonResult, post } from "../../services/FetchServices";
import Location from "../../types/Location";
import PoItem from "../../types/PoItem";
import PoItemShipUnit from "../../types/PoItemShipUnit";
import PurchaseOrderRelease from "../../types/PurchaseOrderRelease";
import SearchPurchaseOrderRelease from "../../types/SearchPurchaseOrderRelease";
import CollapsibleSection from "../collapsibleSection/CollapsibleSection";
import { AutoDropDown } from "../dropDown/AutoDropDown";
import { DropDown } from "../dropDown/DropDown";
import { FlagableTextField, focusOnField } from "./FlagableTextField";
import PoItemShipUnitPage from "./PoItemShipUnitPage";

interface IState {
  purchaseOrderRelease?: PurchaseOrderRelease;
  hazmatCodes: string[];
  searchPurchaseOrder?: SearchPurchaseOrderRelease;
}

const PurchaseOrderReleasePage: React.FC = () => {
  const history = useHistory();
  const purchaseOrderRelease = useLocation();
  const nmfcDefaultValue = "70";
  const purchaseOrder = (purchaseOrderRelease?.state as IState)
    ?.purchaseOrderRelease;
  const searchPurchaseOrder = (purchaseOrderRelease?.state as IState)
    ?.searchPurchaseOrder;
  const [vendorId, setVendorId] = useState("");
  const [masterVendorName, setMasterVendorName] = useState("");
  const [orderBaseGid, setOrderBaseGid] = useState("");
  const [orderReleaseId, setOrderReleaseId] = useState("");
  const [shipFrom, setShipFrom] = useState("");
  const [shipTo, setShipTo] = useState("");
  const [shipToAddress, setShipToAddress] = useState("");
  const [freightTerms, setFreightTerms] = useState("");
  const [earlyProductReadyDate, setEarlyProductReadyDate] =
    useState<Date | null>(null);
  const [earlyProductReadyDateMinimum, setEarlyProductReadyDateMinimum] =
    useState<Date | null>(null);
  const [lateProductReadyDate, setLateProductReadyDate] = useState<Date | null>(
    null,
  );
  const [advancedOption, setAdvancedOption] = useState("");
  const [earlyShipPoDate, setEarlyShipPoDate] = useState<Date | null>(null);
  const [earlyShipDate, setEarlyShipDate] = useState<Date | null>(null);
  const [earlyShipPoDateDup, setEarlyShipPoDateDup] = useState<Date | null>(
    null,
  );
  const [earlyProductReadyDateStart, setEarlyProductReadyDateStart] =
    useState<Date>(new Date());
  const [earlyProductReadyDateEnd, setEarlyProductReadyDateEnd] =
    useState<Date>(new Date());
  const [lateShipPoDate, setLateShipPoDate] = useState<Date | null>(null);
  const [lateShipPoDateMax, setLateShipPoDateMax] = useState<Date | null>(null);
  const [shipFromOverride, setShipFromOverride] = useState("");
  const [shipFromOverrides, setShipFromOverrides] = useState<Location[]>([]);
  const [pickupNumber, setPickupNumber] = useState("");
  const [poItems, setPoItems] = useState<PoItem[]>([]);
  const [feasiblePOs, setFeasiblePOs] = useState<PurchaseOrderRelease[]>([]);
  const [planToLocationGid, setPlanToLocationGid] = useState("");
  const [dcOptions, setDcOptions] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const nmfcClasses = [
    "50",
    "55",
    "60",
    "65",
    "70",
    "77.5",
    "85",
    "92.5",
    "100",
    "110",
    "125",
    "150",
    "175",
    "200",
    "250",
    "300",
    "400",
    "500",
  ];

  const hazmats = ["No", "Yes"];
  const [poItemShipUnits, setPoItemShipUnits] = useState<PoItemShipUnit[]>([]);
  const [shippingOriginRemarks, setShippingOriginRemarks] = useState("");
  const [wareHouseRemarks, setWareHouseRemarks] = useState("");
  const [hasValidationErrors, setHasValidationErrors] = useState(false);
  const [hasShipQuantityValidationErrors, setHasShipQuantityValidationErrors] =
    useState(false);
  const [isEarlyProductReadyDateNotValid, setEarlyProductReadyDateNotValid] =
    useState(false);
  const [openSuccessAlert, setSuccessAlertOpen] = useState(false);
  const [openFailureAlert, setFailureAlertOpen] = useState(false);
  const [failureDailogContent, setFailureDailogContent] = useState("");
  var hazmatCodes = (purchaseOrderRelease?.state as IState)?.hazmatCodes;

  let nmfcClassSet = new Set();
  const authHeader = localStorage.getItem("authHeader");
  const username = localStorage.getItem("userName");
  const [selectAll, setSelectAll] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (shipFromOverrides.length === 0) {
      findAllLocations();
    }
  }, []);

  useEffect(() => {
    setVendorId(localStorage.getItem("vendorId") ?? "");

    if (purchaseOrder !== undefined) {
      setVendorId(purchaseOrder?.vendorId);
      setMasterVendorName(purchaseOrder?.masterVendorName);
      setOrderBaseGid(purchaseOrder?.orderBaseId);
      setShipFrom(purchaseOrder?.shipFrom);
      setFreightTerms(purchaseOrder?.freightTerms);
      setEarlyShipDate(parseDateOrNull(purchaseOrder?.earlyShipDate));
      const initialEarlyProductReadyDate = parseDateOrNull(
        purchaseOrder?.earlyProductReadyDate,
      );
      setEarlyProductReadyDate(initialEarlyProductReadyDate);
      setEarlyProductReadyDateStart(
        parseDateOrNull(purchaseOrder?.earlyProductReadyDateStart) ??
          new Date(),
      );
      setEarlyProductReadyDateEnd(
        parseDateOrNull(purchaseOrder?.earlyProductReadyDateEnd) ?? new Date(),
      );
      setEarlyProductReadyDateMinimum(
        parseDateOrNull(purchaseOrder?.earlyProductReadyDateMinimum),
      );
      const parsedEarlyShipPoDate = parseDateOrNull(
        purchaseOrder?.earlyShipPoDate,
      );
      setEarlyShipPoDate(parsedEarlyShipPoDate);
      setShipTo(purchaseOrder?.shipTo);
      setPoItems(purchaseOrder?.items);
      setPoItemShipUnits(purchaseOrder?.itemShipUnits);
      setPickupNumber(purchaseOrder?.vendorPickupNumber);
      setWareHouseRemarks(purchaseOrder?.wareHouseRemarks);
      setPlanToLocationGid(purchaseOrder?.planToLocationGid);
      const parsedLateShipPoDate = parseDateOrNull(
        purchaseOrder?.lateShipPoDate,
      );
      setLateShipPoDate(parsedLateShipPoDate);
      if (initialEarlyProductReadyDate) {
        setLateProductReadyDateWithOffset(initialEarlyProductReadyDate);
      } else {
        setLateProductReadyDate(
          parseDateOrNull(purchaseOrder?.lateProductReadyDate),
        );
      }
    }
  }, [purchaseOrder]);

  useEffect(() => {
    if (dcOptions.length === 0) {
      getDestinationDetails();
    }
  }, [purchaseOrder]);

  useEffect(() => {
    if (shipToAddress) {
      getFeasiblePurchaseOrderList();
    }
  }, [shipToAddress]);

  useEffect(() => {
    const allSelected = feasiblePOs.every((po) => po.isSelected);
    const noneSelected = feasiblePOs.every((po) => !po.isSelected);

    if (allSelected && feasiblePOs.length > 0) {
      setSelectAll(true);
    } else if (noneSelected) {
      setSelectAll(false);
    } else {
      setSelectAll(false);
    }
  }, [feasiblePOs]);

  const parsePoDate = (dateStr: string) => {
    if (!dateStr) {
      return null;
    }
    const [year, month, day] = dateStr.split("T")[0].split("-").map(Number);
    if (!year || !month || !day) {
      return null;
    }
    return new Date(year, month - 1, day);
  };

  const updateShipPoDatesFromItems = (items: PoItem[]) => {
    const earlyDates = items
      .map((item) => parsePoDate(item.earlyPickupDate))
      .filter((date): date is Date => date !== null);
    const lateDates = items
      .map((item) => parsePoDate(item.latePickupDate))
      .filter((date): date is Date => date !== null);

    if (earlyDates.length > 0) {
      const minEarlyDate = new Date(
        Math.min(...earlyDates.map((date) => date.getTime())),
      );
      setEarlyShipPoDate(minEarlyDate);
    }

    if (lateDates.length > 0) {
      const maxLateDate = new Date(
        Math.max(...lateDates.map((date) => date.getTime())),
      );
      setLateShipPoDate(maxLateDate);
    }
  };

  const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked;
    setSelectAll(checked);

    setFeasiblePOs((prevPOs) =>
      prevPOs.map((po) => ({
        ...po,
        isSelected: checked,
      })),
    );

    let newPoItems: PoItem[];
    if (checked) {
      const initialItems = poItems.filter(
        (item) => item.poId === purchaseOrder?.purchaseOrderId,
      );
      const allFeasibleItems = feasiblePOs.flatMap((po) => po.items);
      newPoItems = [...initialItems, ...allFeasibleItems];
    } else {
      setFeasiblePOs((prevPOs) =>
        prevPOs.map((po) => {
          const newPo = {
            ...po,
            items: po.items.map((item) => ({
              ...item,
              shipQuantity: 0,
              cartons: 0,
              nmfc: nmfcDefaultValue,
              unCode: "",
              hazmat: false,
              shipQuantityWithCommas: false,
            })),
          };
          return newPo;
        }),
      );

      newPoItems = poItems.filter(
        (item) => item.poId === purchaseOrder?.purchaseOrderId,
      );
    }
    setPoItems(newPoItems);
    updateShipPoDatesFromItems(newPoItems);
    calculateShipUnits(newPoItems);
  };

  const handleRowCheckboxChange = (
    purchaseOrderId: string,
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const checked = event.target.checked;

    let newPoItems: PoItem[];
    setFeasiblePOs((prevPOs) =>
      prevPOs.map((po) => {
        const newPo = {
          ...po,
          isSelected:
            po.purchaseOrderId === purchaseOrderId ? checked : po.isSelected,
        };
        if (newPo.purchaseOrderId === purchaseOrderId && !checked) {
          newPo.items = newPo.items.map((item) => ({
            ...item,
            shipQuantity: 0,
            cartons: 0,
            nmfc: nmfcDefaultValue,
            unCode: "",
            hazmat: false,
            shipQuantityWithCommas: false,
          }));
        }
        return newPo;
      }),
    );

    if (checked) {
      newPoItems = [
        ...poItems,
        ...feasiblePOs
          ?.filter((po) => po?.purchaseOrderId === purchaseOrderId)
          ?.flatMap((po) => po.items),
      ];
    } else {
      newPoItems = poItems.filter((item) => item.poId !== purchaseOrderId);
    }
    setPoItems(newPoItems);
    updateShipPoDatesFromItems(newPoItems);
    calculateShipUnits(newPoItems);
  };

  const closeSuccessAlertDialog = () => {
    setSuccessAlertOpen(false);
    history.push("/searchPurchaseOrderRelease");
  };

  const closeFailureAlertDialog = () => {
    setFailureAlertOpen(false);
  };

  const setLateProductReadyDateWithOffset = (date: Date | null) => {
    if (!date || Number.isNaN(date.getTime())) {
      setLateProductReadyDate(null);
      return;
    }
    const offset = businessDaysToAdd(date);
    setLateProductReadyDate(addBusinessDays(date, offset));
  };

  const businessDaysToAdd = (date: Date | null): number => {
    if (!date || Number.isNaN(date.getTime())) {
      return 0;
    }
    const day = date.getDay();
    return day === 0 || day === 6 ? 3 : 2;
  };

  const addBusinessDays = (date: Date, days: number) => {
    const result = new Date(date.getTime());
    let addedDays = 0;
    while (addedDays < days) {
      result.setDate(result.getDate() + 1);
      const dayOfWeek = result.getDay();
      if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        addedDays += 1;
      }
    }
    return result;
  };

  const findAllLocations = () => {
    setIsLoading(true);
    const findLocationUrl =
      `${process.env.REACT_APP_BACKEND_URL}/matm/findLocation/search?vendorId=` +
      localStorage.getItem("vendorId");
    post(findLocationUrl, { activeStatus: "Y" })
      .then((response) => response.json())
      .then((data) => {
        if (data !== null && data.length > 0) {
          setShipFromOverrides(data);
        }
        setIsLoading(false);
      });
  };

  const handleShipFromOverride = (e: any) => {
    setIsLoading(true);
    setShipFromOverride(e.target.value);
    var filteredLocation = shipFromOverrides?.filter(
      (item: { locationXId: string }) => item.locationXId === e.target.value,
    );
    setShippingOriginRemarks(filteredLocation[0]?.remark);
    setIsLoading(false);
  };

  const handleShipingOriginRemarks = (
    e: React.ChangeEvent<HTMLTextAreaElement>,
  ) => {
    setShippingOriginRemarks(e.target.value);
  };

  const handleAdvancedSelection = (
    e: React.ChangeEvent<HTMLTextAreaElement>,
  ) => {
    const selectedValue = e.target.value;
    setAdvancedOption(selectedValue);
  };

  const handlePickupNumber = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPickupNumber(
      e.target.value.replace(/[^a-zA-Z0-9-,.;=+()!@#$%{}/]/g, ""),
    );
  };

  const handleShipQuantityValidation = () => {
    var hasErrors = poItems?.some((item: PoItem) =>
      isInvalidShipQuantityValue(item),
    );
    setHasShipQuantityValidationErrors(hasErrors);
  };

  const handleShipQuantityOnBlur = (e: any) => {
    const itemId: string = e.target.getAttribute("data-item-id");
    const poId: string = e.target.getAttribute("data-po-id");
    const newPoItems: PoItem[] = [...poItems];
    const item: PoItem = newPoItems.find(
      (i) => i.itemId === itemId && i.poId === poId,
    )!;
    item.shipQuantityWithCommas = false;
    setPoItems(newPoItems);
  };

  const handleShipQuantityOnFocus = (e: any) => {
    const itemId: string = e.target.getAttribute("data-item-id");
    const poId: string = e.target.getAttribute("data-po-id");
    const newPoItems: PoItem[] = [...poItems];
    const item: PoItem = newPoItems.find(
      (i) => i.itemId === itemId && i.poId === poId,
    )!;
    item.shipQuantityWithCommas = true;
    setPoItems(newPoItems);
  };

  const handleShipQuantity = (e: any) => {
    const qty = e.target.value.replace(/[^0-9\s]/g, "");
    const itemId = e.target.getAttribute("data-item-id");
    const poId = e.target.getAttribute("data-po-id");
    const newPoItems: PoItem[] = [...poItems];
    const item = newPoItems.find(
      (i) => i.itemId === itemId && i.poId === poId,
    )!;

    item.shipQuantity = qty;
    item.cartons = Math.ceil(Number(qty) / item.quantityPerCarton);

    setPoItems(newPoItems);

    const resolvedNmfc =
      item.nmfc === null ||
      item.nmfc === undefined ||
      item.nmfc === "null" ||
      item.nmfc === ""
        ? nmfcDefaultValue
        : item.nmfc;

    calculateShipUnits(newPoItems, [resolvedNmfc]);
    handleShipQuantityValidation();
  };

  const handlenmfc = (e: any) => {
    const itemId = e.target.getAttribute("data-item-id");
    const poId = e.target.getAttribute("data-po-id");
    const newPoItems: PoItem[] = [...poItems];
    const item = newPoItems.find(
      (i) => i.itemId === itemId && i.poId === poId,
    )!;

    const oldNmfc =
      item.nmfc === null ||
      item.nmfc === undefined ||
      item.nmfc === "null" ||
      item.nmfc === ""
        ? nmfcDefaultValue
        : item.nmfc;

    const eventValue = e.target.value;
    const newNmfc =
      eventValue === null ||
      eventValue === undefined ||
      eventValue === "null" ||
      eventValue === ""
        ? nmfcDefaultValue
        : eventValue;

    item.nmfc = eventValue;
    setPoItems(newPoItems);
    const qty = item.shipQuantity;

    if (qty !== undefined && qty !== null && qty !== 0) {
      calculateShipUnits(newPoItems, [oldNmfc, newNmfc]);
    } else {
      calculateShipUnits(newPoItems);
    }
  };

  const calculateShipUnits = (
    currentPoItems: PoItem[],
    resetNmfcs: string[] = [],
  ) => {
    const shipUnitsArray: PoItemShipUnit[] = [];
    const nmfcClassSet = new Set<string>();
    const totalCartonsMap = new Map<string, number>();

    const nmfcTemplateMap = new Map<string, PoItemShipUnit>(
      poItemShipUnits.map((unit) => [unit.nmfcClass, unit]),
    );

    currentPoItems.forEach((item) => {
      if (!item.shipQuantity || item.shipQuantity <= 0) return;

      const itemNmfc =
        item.nmfc === "null" || !item.nmfc ? nmfcDefaultValue : item.nmfc;

      const currentCartons = totalCartonsMap.get(itemNmfc) ?? 0;
      const newTotalCartons = currentCartons + (item.cartons ?? 0);
      totalCartonsMap.set(itemNmfc, newTotalCartons);

      if (!nmfcClassSet.has(itemNmfc)) {
        const existingInState = poItemShipUnits.find(
          (u) => u.nmfcClass === itemNmfc,
        );
        const template = nmfcTemplateMap.get(itemNmfc);

        const shouldReset = resetNmfcs.includes(itemNmfc) || !existingInState;

        const newShipUnit = new PoItemShipUnit(
          existingInState?.shipUnitId ?? itemNmfc,
          shouldReset ? "PALLET" : (existingInState?.loadMethod ?? "PALLET"),
          shouldReset
            ? "PALLET"
            : (existingInState?.priorLoadMethod ?? "PALLET"),
          shouldReset ? 0 : (existingInState?.pallet ?? 0),
          shouldReset ? 0 : (existingInState?.palletSpaces ?? 0),
          shouldReset ? 0 : (existingInState?.volume ?? 0),
          shouldReset ? 0 : (existingInState?.weight ?? 0),
          newTotalCartons,
          itemNmfc,
          shouldReset ? 0 : (existingInState?.volume ?? 0),
          true,
          true,
          shouldReset ? false : (existingInState?.oversized ?? false),
          template?.existingUnit ?? false,
        );

        nmfcClassSet.add(itemNmfc);
        shipUnitsArray.push(newShipUnit);
      } else {
        const existingUnit = shipUnitsArray.find(
          (u) => u.nmfcClass === itemNmfc,
        );
        if (existingUnit) {
          existingUnit.cartons = newTotalCartons;
        }
      }
    });

    setPoItemShipUnits([...shipUnitsArray]);
  };

  const handleHazmat = (e: any) => {
    const itemId: string = e.target.getAttribute("data-item-id");
    const poId: string = e.target.getAttribute("data-po-id");
    const newPoItems: PoItem[] = [...poItems];
    const item: PoItem = newPoItems.find(
      (i) => i.itemId === itemId && i.poId === poId,
    )!;
    if (e.target.value === "No") {
      item.unCode = "";
    }
    item.hazmat = e.target.value === "Yes" ? true : false;
    setPoItems(newPoItems);
  };

  const handleUnCode = (itemId: string, poId: string, newValue: string) => {
    const newPoItems = [...poItems];
    const item = newPoItems.find((i) => i.itemId === itemId && i.poId === poId);

    if (item) {
      item.unCode = newValue || "";
      setPoItems(newPoItems);
    }
  };

  const handleWareHouseRemarks = (
    e: React.ChangeEvent<HTMLTextAreaElement>,
  ) => {
    setWareHouseRemarks(
      e.target.value.replace(/[^a-zA-Z0-9-,.;=+()!@#$%{}/\s]/g, ""),
    );
  };

  const parseDateOrNull = (
    value?: string | number | Date | null,
  ): Date | null => {
    if (value === undefined || value === null || value === "") {
      return null;
    }
    const parsedDate = new Date(value);
    return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
  };

  const convertDate = (dateTime: Date, timeZone: string) => {
    let date = ("0" + dateTime.getDate()).slice(-2);
    let month = ("0" + (dateTime.getMonth() + 1)).slice(-2);
    let year = dateTime.getFullYear();
    let covertedDate = year + "-" + month + "-" + date + timeZone;
    return covertedDate;
  };

  const convertDateStr = (dateTimeStr: string) => {
    let dateTime = new Date(dateTimeStr);
    let date = ("0" + dateTime.getDate()).slice(-2);
    let month = ("0" + (dateTime.getMonth() + 1)).slice(-2);
    let year = dateTime.getFullYear();
    let covertedDate = year + "-" + month + "-" + date;
    return covertedDate;
  };

  let itemLineNumber = 0;
  const getShipUnitLines = (nmfc: string, shipUnitGid: string) => {
    let shipUnitLines: any = [];
    let shipUnitLineNumber = 0;
    poItems.forEach((row: PoItem) => {
      if (row.shipQuantity > 0 && row.nmfc === nmfc) {
        shipUnitLines.push({
          transactionCode: "IU",
          shipUnitLineBeanData: {
            shipUnitGid: shipUnitGid,
            shipUnitLineNo: shipUnitLineNumber + 1,
            orderReleaseLineGid: orderReleaseId + "-" + itemLineNumber,
            packagedItemGid: row.itemId,
            obLineGid: row.obLineGid,
          },
        });
        shipUnitLineNumber++;
        itemLineNumber++;
      }
    });
    return shipUnitLines;
  };

  const getDestinationDetails = () => {
    setIsLoading(true);
    const orderReleaseUrl = `${process.env.REACT_APP_BACKEND_URL}/matm/dcCity/${purchaseOrder?.destination}`;

    getJsonResult(orderReleaseUrl)
      .then((response) => response.json())
      .then((data) => {
        setDcOptions(data);
        setDestinationValue(data);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const formatToMMDDYYYY = (dateStr: string) => {
    if (!dateStr) return dateStr;
    const onlyDate = dateStr.split("T")[0];
    const [year, month, day] = onlyDate.split("-");
    return `${month}/${day}/${year}`;
  };

  const getFeasiblePurchaseOrderList = () => {
    setIsLoading(true);
    const activePoItems = poItems.filter(
      (item) =>
        !item.cancelled &&
        item.remainingQuantity != null &&
        item.remainingQuantity > 0,
    );

    if (activePoItems.length === 0) {
      setIsLoading(false);
      setFeasiblePOs([]);
      return;
    }

    const maxEarlyPickupDate = activePoItems.reduce((max, item) => {
      const current = item.earlyPickupDate;
      return current > max ? current : max;
    }, activePoItems[0].earlyPickupDate);

    const minLatePickupDate = activePoItems.reduce((min, item) => {
      const current = item.latePickupDate;
      return current < min ? current : min;
    }, activePoItems[0].latePickupDate);

    const feasiblePOSearchUrl = `${process.env.REACT_APP_BACKEND_URL}/api/purchaseOrder/feasibleSearch`;
    const feasiblePOSearchRequest = {
      earlyProductReadyDate: document
        ?.getElementById("earlyShipReleaseDate")
        ?.getAttribute("value"),
      lateProductReadyDate: document
        ?.getElementById("lateShipReleaseDate")
        ?.getAttribute("value"),
      feasiblePOStartDate: formatToMMDDYYYY(maxEarlyPickupDate),
      feasiblePOEndDate: formatToMMDDYYYY(minLatePickupDate),
      freightTerms: freightTerms,
      shipTo: shipToAddress.split(" ")[0],
      vendorId: vendorId,
      requestFrom: "createOrderRelease",
      intialPurchaseOrderId: purchaseOrder?.purchaseOrderId,
    };

    post(feasiblePOSearchUrl, feasiblePOSearchRequest)
      .then((response) => {
        if (response.status >= 200 && response.status <= 299) {
          return response.json();
        } else {
          throw response;
        }
      })
      .then((data) => {
        const filteredPoItems = poItems.filter(
          (item) => item.poId === purchaseOrder?.purchaseOrderId,
        );
        setPoItems(filteredPoItems);
        updateShipPoDatesFromItems(filteredPoItems);
        calculateShipUnits(filteredPoItems);
        setFeasiblePOs(data);
      })
      .catch((error) => {
        error.text().then((errMessage: any) => {
          setFailureDailogContent(
            "Error when fetching Feasible Purchase Order list:\n" + errMessage,
          );
        });
        setFailureAlertOpen(true);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const setDestinationValue = (dcOptions: string[]) => {
    dcOptions.forEach((eachOption) => {
      if (eachOption?.split(" ")[0] === purchaseOrder?.destination) {
        setShipToAddress(eachOption);
      }
    });
  };

  const finishOrderRelease = () => {
    if (isSubmitting) return;

    setIsSubmitting(true);

    itemLineNumber = 0;

    poItems.forEach((row: PoItem) => {
      return {
        ...row,
        originFacilityId: shipFromOverride,
        destinationFacilityId: shipToAddress?.split(" ")[0],
      };
    });

    let shipUnits: any = [];
    poItemShipUnits?.forEach((shipUnit: PoItemShipUnit) => {
      let shipUnitGid = orderReleaseId + "-" + shipUnit.shipUnitId;
      shipUnits.push({
        shipUnitBeanData: {
          shipUnitGid: shipUnitGid,
          shipUnitXid: shipUnitGid?.split(".")[1],
          unitWeight: {
            value:
              shipUnit.pallet > 0
                ? shipUnit.weight / shipUnit.pallet
                : shipUnit.weight / shipUnit.cartons, // floor load method
            uomCode: "LB",
          },
          unitVolume: {
            value:
              shipUnit.pallet > 0
                ? shipUnit.volume / shipUnit.pallet
                : shipUnit.volume / shipUnit.cartons, // floor load method
            uomCode: "CUFT",
          },
          orderReleaseId: orderReleaseId,
          shipUnitCount:
            shipUnit.pallet > 0 ? Number(shipUnit.pallet) : shipUnit.cartons,
          totalGrossWeight: {
            value: shipUnit.weight / 1,
            uomCode: "LB",
          },
          totalGrossVolume: {
            value: shipUnit.volume / 1,
            uomCode: "CUFT",
          },
          attributeNumber1: Number(shipUnit.palletSpaces),
          unitNetWeight: {
            value:
              shipUnit.pallet > 0
                ? shipUnit.weight / shipUnit.pallet
                : shipUnit.weight / shipUnit.cartons,
            uomCode: "LB",
          },
          unitNetVolume: {
            value:
              shipUnit.pallet > 0
                ? shipUnit.volumeBkp / shipUnit.pallet
                : shipUnit.volumeBkp / shipUnit.cartons,
            uomCode: "CUFT",
          },
          flexCommodityCode: shipUnit.nmfcClass,
          flexCommodityQualGid: "NMFC_CLASS",
          shipUnitLine: getShipUnitLines(shipUnit.nmfcClass, shipUnitGid),
        },
      });
    });

    const filteredItems = poItems
      ?.filter((item) => item?.shipQuantity && item?.shipQuantity > 0)
      .map((item) => {
        item.nmfc =
          !item.nmfc || item.nmfc === "null" ? nmfcDefaultValue : item.nmfc;
        return item;
      });
    filteredItems.forEach((item) => {
      if (!item?.cancelled) {
        item.cancelled = false;
      }
    });
    let orderJson = {
      purchaseOrderId: purchaseOrder?.purchaseOrderId,
      vendorId: vendorId,
      shipFrom: shipFromOverride,
      shipTo: shipToAddress?.split(" ")[0],
      earlyPickupDate:
        earlyProductReadyDate !== null
          ? convertDate(earlyProductReadyDate, "T00:00:01")
          : null,
      latePickupDate:
        lateProductReadyDate !== null
          ? convertDate(lateProductReadyDate, "T23:59:00")
          : null,
      earlyDeliveryDate:
        earlyShipPoDate !== null
          ? convertDate(earlyShipPoDate, "T00:00:01")
          : null,
      lateDeliveryDate:
        lateShipPoDate !== null
          ? convertDate(lateShipPoDate, "T23:59:00")
          : null,
      freightTerms: freightTerms,
      items: filteredItems,
      itemShipUnits: poItemShipUnits,
      vendorPickupNumber: pickupNumber,
      wareHouseRemarks: wareHouseRemarks,
      dtreLiftgateRequired: advancedOption === "LIFTGATE" ? "LIFTGATE" : "",
    };

    var createOrderReleaseUrl = `${process.env.REACT_APP_BACKEND_URL}/api/orderRelease/create`;
    post(createOrderReleaseUrl, orderJson)
      .then((response) => {
        if (response.status >= 200 && response.status <= 299) {
          return response.text();
        } else {
          throw response;
        }
      })
      .then((data) => {
        setOrderReleaseId(data);
        setSuccessAlertOpen(true);
      })
      .catch((error) => {
        setIsSubmitting(false);
        error.text().then((errMessage: any) => {
          setFailureDailogContent(
            "Error when finishing OrderRelease:\n" + errMessage,
          );
        });
        setFailureAlertOpen(true);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const validationHandler = (hasErrors: boolean) => {
    setHasValidationErrors(hasErrors);
  };

  const shipComplete = () => {
    const newPoItems: PoItem[] = [...poItems];
    const affectedNmfcs = new Set<string>();

    newPoItems.forEach((item) => {
      const safeQuantityPerCarton =
        !item.quantityPerCarton || item.quantityPerCarton === 0
          ? 1
          : item.quantityPerCarton;

      if (item.remainingQuantity > 0) {
        const fullCartons = Math.floor(
          item.remainingQuantity / safeQuantityPerCarton,
        );
        item.shipQuantity = fullCartons * safeQuantityPerCarton;

        if (item.shipQuantity > 0) {
          item.cartons = item.shipQuantity / safeQuantityPerCarton;

          const currentNmfc =
            item.nmfc === null ||
            item.nmfc === undefined ||
            item.nmfc === "null" ||
            item.nmfc === ""
              ? nmfcDefaultValue
              : item.nmfc;

          affectedNmfcs.add(currentNmfc);
        } else {
          item.cartons = 0;
        }
      } else {
        item.shipQuantity = 0;
        item.cartons = 0;
      }
    });

    setPoItems(newPoItems);
    calculateShipUnits(newPoItems, Array.from(affectedNmfcs));
  };
  const cancel = () => {
    history.push({
      pathname: "/searchPurchaseOrderRelease",
      state: {
        searchPurchaseOrder: searchPurchaseOrder,
        navigatedBack: true,
      },
    });
  };

  const validateEarlyShipReleaseDate = (
    newValue: Date | null,
    earlyShipReleaseDateStart: Date,
    earlyShipReleaseDateEnd: Date,
  ) => {
    setEarlyProductReadyDateNotValid(
      newValue !== null
        ? !(
            newValue >= earlyShipReleaseDateStart &&
            newValue <= earlyShipReleaseDateEnd
          )
        : true,
    );
  };

  const isFormConflicted = () => {
    return (
      shipFromOverride?.length === 0 ||
      isEarlyProductReadyDateNotValid ||
      hasValidationErrors ||
      hasShipQuantityValidationErrors ||
      poItemShipUnits?.length === 0 ||
      hasInvalidUnCode(poItems) ||
      isInvalidMaxPickupNumber(pickupNumber) ||
      isInvalidMaxWareHouseRemarks(wareHouseRemarks) ||
      hasInvalidShipUnits(poItemShipUnits) ||
      hasInvalidTotals(poItemShipUnits)
    );
  };

  const goToNextInvalidField = () => {
    if (shipFromOverride?.length === 0) {
      focusOnField("shipFromOverride");
    } else if (hasInvalidShipQuantities(poItems)) {
      const item = poItems?.find(isInvalidShipQuantityValue);
      focusOnField("shipQuantity" + item?.itemId + item?.poId);
    } else if (hasInvalidUnCode(poItems)) {
      const item = poItems?.find(
        (item) => hasInvalidPoItemUnCode(item) && item?.hazmat,
      );
      focusOnField("unCode" + item?.itemId + item?.poId);
    } else if (hasInvalidSlipSheets(poItemShipUnits)) {
      focusOnField(
        "pallet" + poItemShipUnits?.find(isInvalidSlipSheetsValue)?.shipUnitId,
      );
    } else if (hasInvalidPalletSpaces(poItemShipUnits)) {
      focusOnField(
        "palletSpaces" +
          poItemShipUnits?.find(isInvalidPalletSpacesValue)?.shipUnitId,
      );
    }
  };

  return (
    <section className="sectionHeadingPadding">
      <div
        id="purchaseOrderReleasePage"
        style={{ margin: "auto", width: "100%" }}
      >
        <div className="intro-container">
          <div className="shipper-info-container">
            <div
              className="intro"
              style={{ width: "80%", marginRight: "auto", marginLeft: "auto" }}
            >
              <div
                id="purchaseOrderReleaseManager"
                className="section-heading mb-4"
              >
                <span
                  className="section-heading-lower"
                  style={{
                    fontSize: "2rem",
                    textAlign: "center",
                    color: "#6b3a06",
                    fontWeight: 500,
                    paddingBottom: "20px",
                  }}
                >
                  READY TO SHIP MANAGER
                </span>
              </div>
              <form>
                <div style={{ display: "flex" }}>
                  <div style={{ width: "50%" }}>
                    <div className="form-group py-2">
                      <TextField
                        className="form-control"
                        id="vendorId"
                        value={vendorId}
                        variant="outlined"
                        label="Vendor ID"
                        disabled
                        sx={{ width: "25%" }}
                      />
                      <TextField
                        className="form-control"
                        id="masterVendorName"
                        value={masterVendorName}
                        variant="outlined"
                        label="Master Vendor Name"
                        disabled
                        sx={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group py-2">
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          disableFuture
                          label="Early PO Pickup Date"
                          views={["year", "month", "day"]}
                          value={earlyShipPoDate}
                          disableOpenPicker={true}
                          onChange={() => {}}
                          renderInput={(params: any) => (
                            <TextField
                              {...params}
                              id="earlyShipPoDate"
                              className="form-control"
                              helperText={null}
                            />
                          )}
                          disabled
                        />
                      </LocalizationProvider>
                    </div>
                    <div
                      className="form-group py-2"
                      style={{ position: "relative", minHeight: "1px" }}
                    >
                      <div
                        className="text-danger"
                        style={{
                          position: "absolute",
                          right: "92%",
                          marginRight: "20px",
                          width: "260px",
                          whiteSpace: "normal",
                          lineHeight: 1.35,
                          textAlign: "left",
                          display:
                            (earlyProductReadyDate?.getTime() || 0) >
                            (lateShipPoDate?.getTime() || 0)
                              ? "block"
                              : "none",
                        }}
                      >
                        Please note:The selected Early Product Ready Date is
                        after the Late PO Pickup Date and may be subject to an
                        OTIF chargeback penalty
                      </div>
                      <div>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DatePicker
                            label="EARLY PRODUCT READY DATE"
                            views={["year", "month", "day"]}
                            value={earlyProductReadyDate}
                            minDate={earlyProductReadyDateMinimum || new Date()}
                            onChange={(newValue: any) => {
                              setEarlyProductReadyDate(newValue);
                              setLateProductReadyDateWithOffset(newValue);
                              validateEarlyShipReleaseDate(
                                newValue,
                                earlyProductReadyDateStart,
                                earlyProductReadyDateEnd,
                              );
                            }}
                            shouldDisableDate={(date: Date) =>
                              date < new Date(earlyProductReadyDateStart) ||
                              date > new Date(earlyProductReadyDateEnd)
                            }
                            renderInput={(params: any) => (
                              <TextField
                                {...params}
                                id="earlyShipReleaseDate"
                                className="form-control"
                                helperText={null}
                                onKeyDown={(e) => {
                                  e.preventDefault();
                                }}
                              />
                            )}
                          />
                        </LocalizationProvider>
                      </div>
                    </div>
                    <div className="form-group py-2">
                      <FlagableTextField
                        className="form-control"
                        id="shipFromOverride"
                        select
                        label="Ship From Location"
                        value={shipFromOverride}
                        onChange={handleShipFromOverride}
                        SelectProps={{
                          native: true,
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        error={shipFromOverride?.length === 0}
                      >
                        <option key="" value=""></option>
                        {shipFromOverrides?.map((loc: Location) => (
                          <option
                            key={loc?.locationXId}
                            value={loc?.locationXId}
                          >
                            {loc?.locationName +
                              " " +
                              loc?.streetAddress +
                              " " +
                              loc?.city +
                              " " +
                              loc?.provinceCode +
                              " " +
                              loc?.postalCode}
                          </option>
                        ))}
                      </FlagableTextField>
                    </div>
                    <div className="form-group py-2">
                      <TextField
                        className="form-control"
                        id="pickupNumber"
                        value={pickupNumber}
                        onChange={handlePickupNumber}
                        variant="outlined"
                        label="Pickup Number"
                      />
                      <br />
                      {isInvalidMaxPickupNumber(pickupNumber) && (
                        <span
                          id={"pickupNumberError"}
                          style={{
                            fontWeight: "bold",
                            color: "red",
                          }}
                        >
                          Can not exceed 30 characters.
                        </span>
                      )}
                    </div>
                  </div>
                  <div style={{ width: "50%", marginLeft: "75px" }}>
                    <div className="form-group py-2">
                      <TextField
                        className="form-control"
                        id="purchaseOrderId"
                        value={orderBaseGid?.split(".")[1]}
                        variant="outlined"
                        label="Purchase Order ID"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        disabled
                      />
                    </div>
                    <div className="form-group py-2">
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          disableFuture
                          label="Late PO Pickup Date"
                          views={["year", "month", "day"]}
                          value={lateShipPoDate}
                          disableOpenPicker={true}
                          onChange={() => {}}
                          renderInput={(params: any) => (
                            <TextField
                              {...params}
                              id="lateShipPoDate"
                              className="form-control"
                              helperText={null}
                            />
                          )}
                          disabled
                        />
                      </LocalizationProvider>
                    </div>
                    <div className="form-group py-2">
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          label="LATE PRODUCT READY DATE"
                          views={["year", "month", "day"]}
                          value={lateProductReadyDate}
                          disableOpenPicker={true}
                          onChange={() => {}}
                          renderInput={(params: any) => (
                            <TextField
                              {...params}
                              id="lateShipReleaseDate"
                              className="form-control"
                              helperText={null}
                            />
                          )}
                          disabled
                        />
                      </LocalizationProvider>
                    </div>
                    <div className="form-group py-2">
                      <Tooltip
                        title={
                          <div
                            style={{
                              whiteSpace: "pre-line",
                              fontSize: "1.4em",
                            }}
                          >
                            {
                              "Collect: Dollar Tree is responsible for freight. \n\n Prepaid:  Vendor is responsible for freight. \n\n If freight terms are incorrect, please stop and contact your merchant immediately."
                            }
                          </div>
                        }
                      >
                        <TextField
                          className="form-control"
                          id="freightTerms"
                          value={freightTerms}
                          variant="outlined"
                          label="Freight Terms"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                        />
                      </Tooltip>
                    </div>
                    <div className="form-group py-2">
                      <TextField
                        className="form-control"
                        id="shipToValue"
                        value={shipToAddress}
                        variant="outlined"
                        label="Destination"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className="feasible-po-container">
            <h3
              id="feasiblePOHeader"
              style={{
                fontSize: "1.4rem",
                color: "#6b3a06",
                fontWeight: 500,
              }}
            >
              Feasible Ship With POs
            </h3>
            <div className="table-container-scroll">
              <table id="feasiblePOTable">
                <thead style={{ borderBottom: "2px solid black" }}>
                  <tr>
                    <th>
                      <input
                        type="checkbox"
                        id="selectAllPOs"
                        checked={selectAll}
                        className="select-all-checkbox"
                        onChange={handleSelectAll}
                      />
                    </th>
                    <th>Purchase Orders</th>
                    <th>Remaining Qty</th>
                  </tr>
                </thead>
                <tbody>
                  {feasiblePOs?.map(
                    (purchaseOrderRelease: PurchaseOrderRelease) => (
                      <tr>
                        <td>
                          <input
                            id={purchaseOrderRelease.purchaseOrderId}
                            type="checkbox"
                            className="row-checkbox"
                            checked={purchaseOrderRelease?.isSelected}
                            onChange={(e) =>
                              handleRowCheckboxChange(
                                purchaseOrderRelease.purchaseOrderId,
                                e,
                              )
                            }
                          />
                        </td>
                        <td>{purchaseOrderRelease?.purchaseOrderId}</td>
                        <td>{purchaseOrderRelease?.remainingQuantity}</td>
                      </tr>
                    ),
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div
          id="poItemsTable"
          style={{
            whiteSpace: "nowrap",
            margin: "auto",
            textAlign: "center",
            overflow: "auto",
          }}
        >
          <table className="table" style={{ width: "80%", margin: "auto" }}>
            <thead>
              <tr>
                <th>PO ID</th>
                <th>Item ID</th>
                <th>Item description</th>
                <th>
                  Early <br /> Pickup
                </th>
                <th>
                  Late <br /> Pickup
                </th>
                <th>
                  Early <br /> Delivery
                </th>
                <th>
                  Late <br /> Delivery
                </th>
                <th>
                  Ordered <br /> Qty
                </th>
                <th>
                  Remaining <br /> Qty
                </th>
                <th>
                  <button
                    id="shipCompleteButton"
                    type="button"
                    className="btn btn-success"
                    onClick={() => shipComplete()}
                    style={{ backgroundColor: "#006600" }}
                  >
                    Ship Complete
                  </button>{" "}
                  <br />
                  Ship Qty
                </th>
                <th>
                  Qty <br /> Per Carton
                </th>
                <th>Cartons</th>
                <th>NMFC Class</th>
                <th>Hazmat?</th>
                <th>UN Code</th>
              </tr>
            </thead>
            <tbody>
              {poItems?.map((item: PoItem) => (
                <tr>
                  <td>{item?.poId}</td>
                  <td>{item?.itemId}</td>
                  <td>{item?.itemDescription}</td>
                  <td>{convertDateStr(item?.earlyPickupDate)}</td>
                  <td>{convertDateStr(item?.latePickupDate)}</td>
                  <td>{convertDateStr(item?.earlyDeliveryDate)}</td>
                  <td>{convertDateStr(item?.lateDeliveryDate)}</td>
                  <td>
                    {item?.orderedQuantity
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                  </td>
                  <td>
                    {item?.remainingQuantity
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                  </td>
                  <td>
                    <FlagableTextField
                      id={"shipQuantity" + item?.itemId + item?.poId}
                      data-item-id={item?.itemId}
                      data-po-id={item?.poId}
                      name="shipQuantity"
                      className="form-control"
                      value={
                        item?.shipQuantityWithCommas
                          ? item?.shipQuantity.toString().replace(/,/g, "")
                          : item?.shipQuantity
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      }
                      onChange={handleShipQuantity}
                      onBlur={handleShipQuantityOnBlur}
                      onFocus={handleShipQuantityOnFocus}
                      disabled={item?.remainingQuantity <= 0}
                      inputProps={{
                        "data-item-id": item?.itemId,
                        "data-po-id": item?.poId,
                      }}
                    />
                    <br />
                    {isDivisibleShipQuantity(item) && (
                      <span
                        id={"shipQuantityError" + item?.itemId + item?.poId}
                        data-item-id={item?.itemId}
                        data-po-id={item?.poId}
                        style={{
                          fontWeight: "bold",
                          color: "red",
                        }}
                      >
                        Must be divisible <br />
                        by Qty Per Carton.
                      </span>
                    )}
                    {isDivisibleShipQuantity(item) &&
                      isLessThanRemainingQuantity(item) && <br />}
                    {isLessThanRemainingQuantity(item) && (
                      <span
                        id={"shipQuantityError" + item?.itemId + item?.poId}
                        data-item-id={item?.itemId}
                        data-po-id={item?.poId}
                        style={{
                          fontWeight: "bold",
                          color: "red",
                        }}
                      >
                        The Ship Qty must not be <br />
                        greater than Remaining Qty.
                      </span>
                    )}
                  </td>
                  <td>
                    {item.quantityPerCarton
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                  </td>
                  <td>
                    {item.cartons
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                  </td>
                  <td>
                    <DropDown
                      codes={nmfcClasses}
                      elementId={"nmfc" + item?.itemId + item?.poId}
                      data-item-id={item?.itemId}
                      data-po-id={item?.poId}
                      inputProps={{
                        "data-item-id": item?.itemId,
                        "data-po-id": item?.poId,
                      }}
                      value={item?.nmfc}
                      onChange={handlenmfc}
                      defaultValue={nmfcDefaultValue}
                    />
                  </td>
                  <td>
                    <TextField
                      className="form-control"
                      id={"hazmat" + item?.itemId + item?.poId}
                      data-item-id={item?.itemId}
                      data-po-id={item?.poId}
                      name="hazmatDropDown"
                      select
                      value={item?.hazmat ? "Yes" : "No"}
                      defaultValue={"No"}
                      onChange={handleHazmat}
                      inputProps={{
                        "data-item-id": item?.itemId,
                        "data-po-id": item?.poId,
                      }}
                      SelectProps={{
                        native: true,
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      style={{ width: "140px" }}
                    >
                      {hazmats?.map((hazmat) => (
                        <option key={hazmat} value={hazmat}>
                          {hazmat}
                        </option>
                      ))}
                    </TextField>
                  </td>
                  <td>
                    <Tooltip
                      id={"unCodeToolTip" + item?.itemId + item?.poId}
                      data-item-id={item?.itemId}
                      data-po-id={item?.poId}
                      disableHoverListener={!item?.hazmat}
                      open={false}
                      title={
                        <div
                          style={{
                            whiteSpace: "pre-line",
                            fontSize: "1.8em",
                          }}
                          id={"unCodeToolTipOne" + item?.itemId + item?.poId}
                        >
                          {"Provide the UN number of the hazardous substances"}
                        </div>
                      }
                      placement="bottom"
                    >
                      <span style={{ display: "inline-block", width: "140px" }}>
                        <AutoDropDown
                          elementId={"unCode" + item?.itemId + item?.poId}
                          data-item-id={item?.itemId}
                          data-po-id={item?.poId}
                          value={item?.unCode}
                          codes={hazmatCodes}
                          name="unCodeDropDown"
                          disable={!item?.hazmat}
                          required={item?.hazmat}
                          variant="outlined"
                          onChange={(e: any, newValue: any) =>
                            handleUnCode(item?.itemId, item?.poId, newValue)
                          }
                          defaultValue=""
                          sx={{
                            width: "140px",
                            "& .MuiInputBase-root.Mui-disabled": {
                              backgroundColor: "lightgray",
                            },
                            "& .MuiInputBase-input.Mui-disabled": {
                              WebkitTextFillColor: "rgba(0, 0, 0, 0.6)",
                            },
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor:
                                item?.hazmat && hasInvalidPoItemUnCode(item)
                                  ? "red !important"
                                  : "",
                            },
                          }}
                        />
                      </span>
                    </Tooltip>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <br />
        <PoItemShipUnitPage
          poItemShipUnitsProps={poItemShipUnits}
          validationHandler={validationHandler.bind(this)}
        />
      </div>
      <div className="row justify-content-center">
        <div className="col-md" style={{ paddingLeft: "250px", width: "50%" }}>
          <div className="form-group py-2">
            <div className="input-group" style={{ width: "80%" }}>
              <TextField
                id="wareHouseRemarks"
                className="form-control"
                label="Additional Supplier Routing Request Remarks"
                value={wareHouseRemarks}
                onChange={handleWareHouseRemarks}
                minRows={3}
                multiline
              />
            </div>
            {isInvalidMaxWareHouseRemarks(wareHouseRemarks) && (
              <span
                id={"wareHouseRemarksError"}
                style={{
                  fontWeight: "bold",
                  color: "red",
                }}
              >
                Can not exceed 80 characters.
              </span>
            )}
          </div>
        </div>
        <div className="col-md" style={{ paddingRight: "90px", width: "50%" }}>
          <div className="form-group py-2">
            <div className="input-group" style={{ width: "80%" }}>
              <TextField
                className="form-control"
                id="shippingOriginRemarks"
                variant="outlined"
                label="Default Shipping Origin Remarks"
                value={shippingOriginRemarks}
                onChange={handleShipingOriginRemarks}
                disabled
                minRows={3}
                multiline
              />
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          marginLeft: "180px",
          marginRight: "25px",
        }}
      >
        <CollapsibleSection id="advancedOptions" title="Advanced">
          <div
            style={{
              width: "15%",
              marginTop: "10px",
            }}
          >
            <TextField
              id="specialServices"
              select
              label="Special Services"
              className="form-control"
              SelectProps={{
                native: true,
              }}
              InputLabelProps={{
                shrink: true,
              }}
              defaultValue=""
              onChange={handleAdvancedSelection}
            >
              <option key="" value="">
                NONE
              </option>
              <option key="LIFTGATE" value="LIFTGATE">
                LIFTGATE
              </option>
            </TextField>
          </div>
        </CollapsibleSection>
      </div>
      <div className="row justify-content-center m-xl-2">
        <button
          id="goToErrorsButton"
          type="button"
          className="btn"
          style={{
            width: "auto",
          }}
          disabled={!isFormConflicted()}
          onClick={() => goToNextInvalidField()}
        >
          {isFormConflicted() ? "Go to errors" : "No errors"}
        </button>
      </div>
      <div className="row justify-content-center m-xl-2">
        <button
          id="readyToShipFinishButton"
          type="button"
          className="btn btn-success"
          style={{
            width: "auto",
            marginRight: ".4em",
          }}
          disabled={isFormConflicted() || isSubmitting}
          onClick={() => finishOrderRelease()}
        >
          {isSubmitting ? "Submitting..." : "Submit"}
        </button>
        <button
          id="cancelSearchPOButton"
          className="btn btn-dark"
          style={{
            width: "auto",
          }}
          onClick={() => cancel()}
        >
          Back
        </button>
      </div>
      <div className="row justify-content-center">
        <div
          className="col-md"
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <br></br>
          <p>
            <strong>
              By clicking submit, I acknowledge that failure to provide accurate
              and timely information may result in future financial penalties.
            </strong>
          </p>
        </div>
      </div>
      <div id="alertDialog">
        <Dialog open={openSuccessAlert} id="statusDialog">
          <DialogTitle id="statusDialogTitle">Success!</DialogTitle>
          <DialogContent>
            <DialogContentText id="statusDialogText">
              Order {orderReleaseId} created successfully
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              id="statusDialogButton"
              onClick={closeSuccessAlertDialog}
              color="primary"
              autoFocus
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog open={openFailureAlert} id="statusDialog">
          <DialogTitle id="statusDialogText">Error!</DialogTitle>
          <DialogContent>
            <DialogContentText>{failureDailogContent}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              id="statusDialogButton"
              onClick={closeFailureAlertDialog}
              color="primary"
              autoFocus
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </section>
  );
};

export default PurchaseOrderReleasePage;
